// @ts-nocheck

import { i18nInstance } from './i18n';
import { setDefaultOptions } from 'date-fns';
import dateLocales from '../constants/dateLocales';

const instance = i18nInstance().getInstance();

instance.loadTranslations = () => {
  if (typeof window === 'undefined') return;

  if (Object.hasOwnProperty.call(window, 'translations') && Object.keys(window.translations).length !== 0) {
    Object.values(window.translations).forEach(translation => {
      Object.keys(translation).forEach(language => {
        instance.addResourceBundle(language, 'defaultNamespace', translation[language]);
      });
    });
  }

  setDefaultOptions({ locale: dateLocales[instance.language] || dateLocales.en });
};

if (typeof window !== 'undefined') {
  instance.loadTranslations();
}

export const i18n = instance;
